import { VIBE_BG_COLORS, VIBE_LABELS } from "../lib/constants.js";

interface VibeBarProps {
  distribution: Record<number, number>;
  size?: "sm" | "md" | "lg";
}

export default function VibeBar({ distribution, size = "md" }: VibeBarProps) {
  const total = Object.values(distribution).reduce((sum, n) => sum + n, 0);
  if (total === 0) {
    return (
      <div className="flex gap-0.5 rounded-full overflow-hidden bg-slate-800 h-2">
        <div className="w-full bg-slate-700" />
      </div>
    );
  }

  const heights = { sm: "h-1.5", md: "h-2.5", lg: "h-4" };
  const h = heights[size];

  const values = [-2, -1, 0, 1, 2];

  return (
    <div className="space-y-1">
      <div className={`flex gap-0.5 rounded-full overflow-hidden ${h}`}>
        {values.map((v) => {
          const count = distribution[v] || 0;
          const pct = (count / total) * 100;
          if (pct === 0) return null;
          return (
            <div
              key={v}
              className={`${VIBE_BG_COLORS[v]} transition-all`}
              style={{ width: `${pct}%` }}
              title={`${VIBE_LABELS[v]}: ${count} (${Math.round(pct)}%)`}
            />
          );
        })}
      </div>
      {size === "lg" && (
        <div className="flex justify-between text-xs text-slate-500">
          <span>Very Bearish</span>
          <span>Very Bullish</span>
        </div>
      )}
    </div>
  );
}
